import {  CampaignStatus, InventoryStatus, ProductAdStatus, ProductEligibilityStatus, SuggestedAction } from "../infrastructure/enums/meta-data-field.enum";

export const INVENTORY_STATUS_SELECTS = [
    {
        label: 'Out of Stock',
        value: InventoryStatus.OUT_OF_STOCK
    },
    {
        label: 'High Risk',
        value: InventoryStatus.HIGH_RISK
    },
    {
        label: 'Moderate Risk',
        value: InventoryStatus.MODERATE_RISK
    },
    {
        label: 'Well Stocked',
        value: InventoryStatus.WELL_STOCK
    },
]
export const CAMPAIGN_STATUS_SELECTS = [
    {
        label: 'Delivering',
        value: CampaignStatus.ENABLED
    },
    {
        label: 'Paused',
        value: CampaignStatus.PAUSED
    },
    {
        label: 'Archived',
        value: CampaignStatus.ARCHIVED
    }
]

export const PRODUCT_ACTIVE_STATUS_SELECTS = [
  {
    label: 'Active',
    value: true,
    theme: 'success',
  },
  {
    label: 'Paused',
    value: false,
    theme: 'secondary',
  },
];


export const PRODUCT_ELIGIBILITY_STATUS_SELECTS = [
    {
        label: 'Eligible',
        value: ProductEligibilityStatus.ELIGIBLE,
        theme: 'success'
    },
    {
        label: 'Ineligible',
        value: ProductEligibilityStatus.INELIGIBLE,
        theme: 'error'
    },
    {
        label: 'Eligible with Warning',
        value: ProductEligibilityStatus.ELIGIBLE_WITH_WARNING,
        theme: 'warning'
    },
]

export const PRODUCT_AD_STATUS_SELECTS = [
    {
        label: 'Suspended',
        value: ProductAdStatus.SUSPENDED,
        theme: 'tertiary'
    },
    {
        label: 'Paused',
        value: ProductAdStatus.PAUSED,
        theme: 'secondary'
    },
    {
        label: 'Archived',
        value: ProductAdStatus.ARCHIVED,
        theme: 'error'
    },
    {
        label: 'Delivering',
        value: ProductAdStatus.DELIVERING,
        theme: 'success'
    },
    {
        label: 'Eligibility',
        value: ProductAdStatus.ELIGIBILITY,
        theme: 'tertiary'
    },
]

export const SUGGESTED_ACTION_SELECTS = [
    {
        label: 'Pause',
        value: SuggestedAction.PAUSE,
        theme: 'danger',
    },
    {
        label: 'Enable',
        value: SuggestedAction.ENABLE,
        theme: 'success',
    },
    {
        label: 'Optimized',
        value: SuggestedAction.OPTIMIZED,
        theme: 'muted',
    },
];

export const REPRICING_INVENTORY_STATUS_STATE_SELECTS = [
    { label: 'Critical Understock', value: 'UNDERSTOCK_CRITICAL' },
    { label: 'Moderate Understock', value: 'UNDERSTOCK_MODERATE' },
    { label: 'Mild Understock', value: 'UNDERSTOCK_MILD' },
    { label: 'Balanced', value: 'BALANCED' },
    { label: 'High Overstock', value: 'OVERSTOCK_HIGH' },
    { label: 'Critical Overstock', value: 'OVERSTOCK_CRITICAL' },
    { label: 'Stock Out Restocking', value: 'STOCK_OUT_RESTOCKING' },
    { label: 'Stock Out High Demand', value: 'STOCK_OUT_HIGH_DEMAND' },
    { label: 'No Demand', value: 'NO_DEMAND' },
    { label: 'Dead Stock', value: 'DEAD_STOCK' },
    { label: 'Missing Price', value: 'MISSING_PRICE' }
];
